import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { Icons } from "@learningblocks/exp-constants";
const { ChevronDownSolid: OpenIcon } = Icons;
import "./style.scss";
import { FormattedMessage } from "@learningblocks/shared-components/lib/FormattedMessage";
import { sanitizeConfigOptions } from "@labxchange/util-sanitization";

const ENTER_KEY = 13;

export function ContentDropdown(props) {
  const ref = useRef();

  const [open, setOpen] = useState(props.open);
  const [contentHeight, setContentHeight] = useState("none");

  useEffect(() => {
    updateContentHeight();

    window.onresize = function () {
      updateContentHeight();
    };
  }, []);

  const updateContentHeight = () => {
    if (ref.current) {
      setContentHeight(ref.current.scrollHeight + (!open ? 16 : 0));
    }
  };

  const toggleOpen = () => {
    updateContentHeight();
    setOpen(!open);
  };

  return (
    <div className="ContentDropdown_container">
      <div
        className="ContentDropdown_btn"
        role="checkbox"
        aria-checked={open}
        tabIndex="0"
        aria-label={FormattedMessage({
          string: '{ExpandCollapse} the "{dropDownLabel}" section.',
          values: {
            ExpandCollapse: !open
              ? FormattedMessage({
                  string: "Expand",
                })
              : FormattedMessage({
                  string: "Collapse",
                }),
            dropDownLabel:
              props.contentDetails.label !== undefined
                ? FormattedMessage({
                    string: props.contentDetails.label,
                  })
                : FormattedMessage({
                    string: "Dropdown",
                  }),
          },
        })}
        onClick={() => toggleOpen()}
        onKeyDown={(e) => {
          if (e.keyCode === ENTER_KEY) {
            toggleOpen();
          }
        }}
      >
        {props.contentDetails.label === undefined
          ? open
            ? FormattedMessage({
                string: "Collapse",
              })
            : FormattedMessage({
                string: "Expand",
              })
          : FormattedMessage({
              string: props.contentDetails.label,
              sanitizeConfig: sanitizeConfigOptions.ButtonText,
            })}
        <OpenIcon
          className={`ContentDropdown_icon ${open ? "open" : "closed"}`}
          alt=""
        />
      </div>
      <div
        ref={ref}
        className={`ContentDropdown_content ${open ? "open" : "closed"}`}
        aria-hidden={!open}
        style={{
          maxHeight: open ? contentHeight : "0px",
        }}
      >
        <FormattedMessage
          string={props.contentDetails.content}
          sanitizeConfig={sanitizeConfigOptions.BlockText}
          description=""
        />
      </div>
    </div>
  );
}

ContentDropdown.propTypes = {
  contentDropdown: PropTypes.shape({
    /**
     * Label that is displayed as the header for the Dropdown
     */
    label: PropTypes.string,
    /**
     * Content that is given to the particular dropdown.
     */
    content: PropTypes.string.isRequired,
    /**
     * Boolean that is used to check whether the dropdown is open or closed
     */
    open: PropTypes.bool.isRequired,
  }),
};

ContentDropdown.defaultProps = {
  contentDropdown: null,
};
